(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["individual-boxing"] && !Shopify.designMode) return;
  try {
    (() => {
    const variantId = 45923044229255;
    const root = window.Shopify?.routes?.root || '/';
    let queue = Promise.resolve();
    let busy = false;
    let pending = 0;
    let allowingSubmit = false;
    const panels = () => [...document.querySelectorAll('individual-boxing')];
    const boxes = cart => cart.items.filter(item => item.variant_id === variantId);
    const count = cart => cart.items.reduce((total, item) => total + (item.product_type === 'Tap Handles' && item.variant_id !== variantId ? item.quantity : 0), 0);
    async function request(path, body) {
      const response = await fetch(root + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || 'Cart update failed');
      return result;
    }
    function setBusy(value) {
      busy = value;
      panels().forEach(panel => {
        panel.setAttribute('aria-busy', String(value));
        panel.querySelector('input').disabled = value;
      });
    }
    function showError() {
      panels().forEach(panel => {
        panel.hidden = false;
        const error = panel.querySelector('.boxing-error');
        error.textContent = panel.dataset.error;
        error.hidden = false;
      });
    }
    function sections() {
      const list = [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' }];
      for (const id of ['main-cart-items', 'main-cart-footer']) {
        const element = document.getElementById(id);
        if (element) list.push({ id: element.dataset.id, selector: '#' + id });
      }
      return list;
    }
    async function refresh(cart) {
      const list = sections();
      const url = new URL(window.location.href);
      url.searchParams.set('sections', list.map(section => section.id).join(','));
      const response = await fetch(url.toString(), { cache: 'no-store' });
      if (!response.ok) throw new Error('Cart rendering failed');
      const html = await response.json();
      const focusId = document.activeElement?.id;
      for (const section of list) {
        const target = document.querySelector(section.selector);
        if (!target || !html[section.id]) continue;
        const parsed = new DOMParser().parseFromString(html[section.id], 'text/html');
        const source = parsed.querySelector(section.selector);
        if (source) target.innerHTML = source.innerHTML;
        else if (section.id === 'cart-icon-bubble') target.innerHTML = parsed.querySelector('.shopify-section')?.innerHTML || html[section.id];
      }
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', cart.item_count === 0);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cart.item_count === 0);
      const drawer = document.querySelector('cart-drawer');
      document.getElementById('CartDrawer-Overlay')?.addEventListener('click', () => drawer?.close());
      if (drawer?.classList.contains('active') && typeof trapFocus === 'function') trapFocus(document.getElementById('CartDrawer'), drawer.querySelector('.drawer__close'));
      if (focusId) document.getElementById(focusId)?.focus();
    }
    async function reconcile(choice) {
      setBusy(true);
      try {
        let cart = await request('cart.js');
        const existing = boxes(cart);
        const handles = count(cart);
        const wanted = handles >= 10 && (choice ?? existing.length > 0) ? handles : 0;
        const updates = {};
        existing.forEach((item, index) => { if (item.quantity !== (index === 0 ? wanted : 0)) updates[item.key] = index === 0 ? wanted : 0; });
        if (Object.keys(updates).length) cart = await request('cart/update.js', { updates });
        if (wanted > 0 && existing.length === 0) {
          await request('cart/add.js', { items: [{ id: variantId, quantity: wanted }] });
          cart = await request('cart.js');
        }
        await refresh(cart);
        return cart;
      } catch (error) {
        console.error('Individual boxing:', error);
        showError();
        throw error;
      } finally { setBusy(false); }
    }
    function schedule(choice) {
      pending++;
      const next = queue.catch(() => {}).then(() => reconcile(choice));
      queue = next.finally(() => { pending--; });
      queue.catch(() => {});
      return next;
    }
    class IndividualBoxing extends HTMLElement {
      connectedCallback() {
        this.querySelector('input').addEventListener('change', event => {
          event.stopPropagation();
          const selected = event.target.checked;
          schedule(selected).catch(() => { if (this.isConnected) event.target.checked = !selected; });
        });
        const handles = Number(this.dataset.handles);
        const quantity = Number(this.dataset.boxes);
        if (!busy && !pending && quantity > 0 && (handles < 10 || quantity !== handles)) schedule().catch(() => {});
      }
    }
    if (!customElements.get('individual-boxing')) customElements.define('individual-boxing', IndividualBoxing);
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, () => schedule().catch(() => {}));
    window.CraftMarkBeforeCheckout = () => schedule();
    document.addEventListener('submit', event => {
      if (window.CraftMarkGuard) return;
      if (allowingSubmit || !event.submitter?.matches('[name="checkout"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const form = event.target;
      const submitter = event.submitter;
      schedule().then(() => {
        allowingSubmit = true;
        const liveForm = form.id ? document.getElementById(form.id) : form;
        const liveButton = submitter.id ? document.getElementById(submitter.id) : submitter;
        if (liveForm && liveButton) liveForm.requestSubmit(liveButton);
        else window.location.assign(root + 'checkout');
        allowingSubmit = false;
      }).catch(() => {});
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mural-craftmark-handoff"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakMap();
  const printChoices = new Set(['Single Sided', 'Two Sides', 'Four Sides']);
  const supported = new Map([
    ['44253915971719', ['Charcoal', 'Single Sided']], ['44253915775111', ['Charcoal', 'Two Sides']],
    ['44253916364935', ['Ivory White', 'Single Sided']], ['44253916168327', ['Ivory White', 'Two Sides']],
    ['44253916758151', ['Latte Brown', 'Single Sided']], ['44253916561543', ['Latte Brown', 'Two Sides']],
    ['44254238507143', ['Charcoal', 'Four Sides']], ['44254238539911', ['Ivory White', 'Four Sides']],
    ['44254238572679', ['Latte Brown', 'Four Sides']],
  ]);
  function init(block) {
    if (initialized.has(block)) return;
    const root = block.closest('product-info');
    if (!root || String(root.dataset.productId) !== '8514676719751') return;
    const link = block.querySelector('[data-mural-customize]');
    const status = block.querySelector('[data-mural-status]');
    const retry = block.querySelector('[data-mural-retry]');
    let options;
    try { options = JSON.parse(block.dataset.options); } catch { return; }
    if (!link || !status || !Array.isArray(options)) return;
    const colorIndex = options.indexOf('Base Color'), artIndex = options.indexOf('Artwork');
    if (colorIndex < 0 || artIndex < 0) return;
    let available = false, checked = false, checking = false, failed = false;
    const connected = () => block.isConnected && root.contains(block);
    function selected() {
      if (root.hasAttribute('data-option-update-error')) return null;
      const input = root.querySelector('form[action*="/cart/add"] input[name="id"]');
      const picker = [...root.querySelectorAll('variant-selects')].find(node => !node.hidden && !node.classList.contains('hidden') && node.style.display !== 'none');
      const node = picker?.querySelector('[data-selected-variant]');
      if (!input || !node) return null;
      try {
        const variant = JSON.parse(node.textContent);
        if (String(variant?.id) !== input.value || colorIndex < 0 || artIndex < 0) return null;
        const controls = [...picker.querySelectorAll('select, fieldset')];
        const values = controls.map(c => c.matches('select') ? c.value : c.querySelector('input:checked')?.value);
        if (values.length && (values.length !== variant.options.length || values.some((v, i) => v !== variant.options[i]))) return null;
        return variant;
      } catch { return null; }
    }
    function update() {
      if (!connected()) return;
      const variant = selected(), artwork = variant?.options[artIndex];
      const optionError = root.hasAttribute('data-option-update-error');
      const blank = artwork === 'Blank No Art';
      const mapping = supported.get(String(variant?.id));
      const mapped = mapping?.[0] === variant?.options[colorIndex] && mapping?.[1] === artwork;
      const enabled = !!variant?.available && mapped && available;
      link.hidden = !enabled;
      link.style.display = enabled ? 'inline-flex' : 'none';
      if (enabled) {
        const url = new URL('/configure/' + block.dataset.handle, block.dataset.appUrl);
        url.searchParams.set('variant', 'gid://shopify/ProductVariant/' + variant.id);
        url.searchParams.set('return', location.href);
        url.searchParams.set('color', variant.options[colorIndex]);
        // Mural's integrated front/back artwork is the base surface contract.
        // Its Shopify option is simply "Artwork", with no separate topper.
        url.searchParams.set('base', artwork);
        link.href = url.href;
      } else link.removeAttribute('href');
      root.querySelectorAll('form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [type="submit"], .shopify-payment-button, shopify-accelerated-checkout').forEach(control => {
        if (!control.hasAttribute('data-mural-original-display')) control.setAttribute('data-mural-original-display', control.style.display);
        control.style.display = blank ? control.getAttribute('data-mural-original-display') : 'none';
      });
      let message = '';
      if (optionError) message = 'Your selected options could not be loaded. Retry or choose another option.';
      else if (!variant) message = 'Checking your selected options…';
      else if (!variant.available) message = 'This selection is sold out. Choose another option.';
      else if (!blank && (!printChoices.has(artwork) || !mapped)) message = 'This artwork option is not configured. Choose another option.';
      else if (!blank && !available) message = checked ? 'Customization is not available right now. Retry or contact us.' : 'Checking customization availability…';
      status.textContent = message; status.hidden = !message;
      if (retry) {
        retry.hidden = !(optionError || (variant?.available && !blank && mapped && checked && !available));
        retry.style.display = retry.hidden ? 'none' : 'inline-flex';
        retry.disabled = checking && !optionError;
      }
    }
    async function checkAvailability() {
      if (checking || !connected()) return;
      checking = true; checked = false; failed = false; available = false;
      update();
      try {
        for (let attempt = 0; attempt < 3 && connected(); attempt++) {
          let timer;
          try {
            const controller = new AbortController();
            const timeout = new Promise((_, reject) => {
              timer = setTimeout(() => { controller.abort(); reject(new Error('Availability timeout')); }, 15000);
            });
            const result = await Promise.race([
              (async () => {
                const response = await fetch(new URL('/api/products/by-shopify-id?shopifyId=8514676719751', block.dataset.appUrl).href, { credentials: 'omit', cache: 'no-store', signal: controller.signal });
                if (response.status === 408 || response.status === 429 || response.status >= 500) throw new Error('Availability request failed');
                const data = await response.json();
                return response.ok && data.customizable === true && data.slug === block.dataset.handle;
              })(),
              timeout,
            ]);
            available = result; failed = false;
            break;
          } catch {
            failed = true;
            if (attempt < 2 && connected()) await new Promise(resolve => setTimeout(resolve, 500 * (attempt + 1)));
          } finally { clearTimeout(timer); }
        }
      } finally { checked = true; checking = false; update(); }
    }
    initialized.set(block, () => { if (failed) checkAvailability(); });
    retry?.addEventListener('click', () => {
      if (root.hasAttribute('data-option-update-error')) {
        const picker = [...root.querySelectorAll('variant-selects')].find(node => !node.hidden && !node.classList.contains('hidden') && node.style.display !== 'none');
        const control = picker?.querySelector('select, input:checked');
        control?.dispatchEvent(new Event('change', { bubbles: true }));
        update();
      } else if (!checking) checkAvailability();
    });
    root.addEventListener('submit', event => {
      if (event.target.matches('form[action*="/cart/add"]') && selected()?.options[artIndex] !== 'Blank No Art') { event.preventDefault(); event.stopImmediatePropagation(); update(); }
    }, true);
    root.addEventListener('change', update);
    const observer = new MutationObserver(records => { if (records.some(record => !block.contains(record.target))) update(); });
    observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-option-update-error'] });
    checkAvailability();
  }
  function scan() { document.querySelectorAll('[data-mural-craftmark]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true }); else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('product-info:loaded', scan);
  window.addEventListener('online', () => { scan(); document.querySelectorAll('[data-mural-craftmark]').forEach(block => initialized.get(block)?.()); });
  window.addEventListener('pageshow', event => { if (event.persisted) { scan(); document.querySelectorAll('[data-mural-craftmark]').forEach(block => initialized.get(block)?.()); } });
})();
  } catch(e) { console.error(e); }
})();

})();
